// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__m3YIv","buttons":"SendReceipts_buttons__286A2","email":"SendReceipts_email__14Fm7","bookApptTitle":"SendReceipts_bookApptTitle__1vNiy"};